export const openLink = (url: string) => {
  // This is a workaround for Safari, which blocks window.open in async functions
  setTimeout(() => {
    window.open(url, "_blank", "noopener,noreferrer");
  });
};
